// extracted by mini-css-extract-plugin
export default {"mainSwiper":"CourseCarouselBig_mainSwiper__JdDvt"};